import Card from "../Card/Card";
import {Button, ButtonOption} from "../Fundamentals/Button";
import {Dropdown} from "../FormComponents/Dropdown";
import {Types, typeText} from "../../Constants/FeatureFlags/types";
import ListSearch from "../Search/ListSearch";
import React, {useEffect, useState} from "react";
import {FeatureFlags} from "../../Utils/featureFlags";
import {useSearchParams} from "react-router-dom";
import {SearchParams} from "../../Constants/FeatureFlags/searchParams";
import useEditFeatureFlag from "../../Hooks/FeatureFlags/useEditFeatureFlag";
import {bindActionCreators} from "redux";
import {useDispatch} from "react-redux";
import settingsActionsImp from "../../Actions/settingsActions";
import {useTranslation} from "react-i18next";

function FlagSelection({ }) {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams()
    const { enabledFeatureFlags, backendFeatureFlags, externalClients, managedTeams, users, selectedFlags, selectedType, selectedId, clearSelected, selectedItem} = useEditFeatureFlag();
    const [allFeatureFlags, setAllFeatureFlags] = useState(null);
    const dispatch = useDispatch();
    const settingsActions = bindActionCreators(settingsActionsImp, dispatch);

    useEffect(() => {
        if (backendFeatureFlags && enabledFeatureFlags && users && managedTeams && externalClients) {
            const uiFeatureFlags = Object.keys(FeatureFlags)?.map(key => FeatureFlags[key]);
            const distinctFeatureFlags = [...new Set([...uiFeatureFlags, ...backendFeatureFlags])];
            const featureFlags = distinctFeatureFlags.map((flag) => {
                return {name: flag, key: flag}
            });
            setAllFeatureFlags(featureFlags);
        }

    }, [backendFeatureFlags, enabledFeatureFlags, managedTeams, users, externalClients])
    
    const filterItem = query => {
        const items = selectedType === Types.User ? users : managedTeams;
        return items?.filter(user =>
            (user.name.toLowerCase().includes(query.toLowerCase()) || user.email?.toLowerCase().includes(query.toLowerCase())))
    }

    const addFeatureFlags = (flags, type, id) => {
        settingsActions.addFeatureToggles(flags, type, id);
    }

    const setFeatureFlag = (flag) => {
        let flags = searchParams.getAll(SearchParams.Flag);
        const idx = flags.indexOf(flag);
        if (idx > -1) {
            searchParams.delete(SearchParams.Flag);
            flags = flags.filter(f => f !== flag);
            flags.forEach(f => searchParams.append(SearchParams.Flag, f));
        } else {
            searchParams.append(SearchParams.Flag, flag);
        }
        setSearchParams(searchParams);
    };

    const setSelectedType = (type) => {
        searchParams.delete(SearchParams.Id)
        searchParams.set(SearchParams.Type, type);
        setSearchParams(searchParams);
    }

    const setSelectedId = (selected) => {
        searchParams.set(SearchParams.Id, selected.id);
        setSearchParams(searchParams);
    }
    
    const typeOptions = Object.keys(Types).map(key => ({
        id: Types[key],
        name: typeText[Types[key]]
    }));
    
    return <Card> 
        <Card.Header>
            <Card.Header.Title>{t('featureflagscontainer.featureflags')}</Card.Header.Title>
        </Card.Header>
        <Card.Content isLoading={!allFeatureFlags || !enabledFeatureFlags || !externalClients || !managedTeams || !users}>
            <fieldset className="d-grid grid-rows-3 gap-16">
                <div>
                    {allFeatureFlags?.map((flag, index) => {
                        return <Button
                            key={`ff-btn-${flag.key}`}
                            option={selectedFlags.includes(flag.key) ? ButtonOption.PRIMARY : ButtonOption.DEFAULT}
                            onClick={(value) => setFeatureFlag(flag.key)}>{flag.name}</Button>
                    })}
                </div>
                    <div className="d-grid grid-cols-5">
                        <Dropdown onChange={(value) => setSelectedType(value)} options={typeOptions}
                                  value={selectedType} placeholder={t('featureflagscontainer.selecttargettype')}/>
                    </div>
                    <div className="d-grid grid-cols-5">
                        {
                            (selectedType === Types.User || selectedType === Types.Team) &&
                            <ListSearch filterItem={filterItem} onChange={setSelectedId}
                                        labelFunc={(item) => item.name + (item.email ? ` (${item.email})` : '')} defaultSelected={selectedItem ? [selectedItem] : []}/>
                        }
                        {
                            selectedType === Types.Api  &&
                            <Dropdown onChange={(value) => setSelectedId({id: Number(value)})}
                                      value={selectedId} placeholder={t('featureflagscontainer.selectclient')}
                                      options={externalClients}/>
                        }
                    </div>
            </fieldset>
        </Card.Content>
        <Card.Footer>
            <Card.Footer.Buttons>
                <Button onClick={() => clearSelected()}
                        disabled={!(selectedFlags?.length > 0 || selectedType || selectedId)}>
                    {t('featureflagscontainer.clearselection')}
                </Button>
                <Button option={ButtonOption.PRIMARY} onClick={() => addFeatureFlags(selectedFlags, selectedType, selectedId)} disabled={!selectedFlags?.length > 0  || !selectedType || (
                    selectedType !== Types.Worker &&
                    selectedType !== Types.All &&
                    !selectedId
                )}>
                    {t('featureflagscontainer.activefeatureflags')}
                </Button>
            </Card.Footer.Buttons>
        </Card.Footer>
    </Card>
}

export default FlagSelection;